import React, { useState, useEffect, useRef } from "react";
import { Typography, Divider, IconButton, Chip } from "@mui/material";
import Button from "@mui/material/Button";

import { motion } from "framer-motion";

import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import ConfirmarMudarPlano from "../../components/ConfirmarMudarPlano";
import AlertSuccess from "../../components/AlertSuccess";
import { gerarLinkWhatsApp } from "../../../utils/WhatsappLink";

const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.3, duration: 0.6, ease: "easeOut" },
    }),
};

const chipVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: (i) => ({
        opacity: 1,
        x: 0,
        transition: { delay: i * 0.1, duration: 0.3, ease: "easeOut" },
    }),
};

const planosChip = {
    "Essencial": [
        { label: "Faturamento da PJ até: R$ 20.000/mês", icon: <CheckIcon color="success" /> },
        { label: "Composição societária: até 1 sócio", icon: <CheckIcon color="success" /> },
        { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", icon: <CheckIcon color="success" /> },
        { label: "Obrigações fiscais/contábeis: dentro do Simples Nacional", icon: <CheckIcon color="success" /> },
        { label: "Certificado digital incluso: apenas no plano anual", icon: <CheckIcon color="success" /> },
        { label: "Regime tributário: Simples Nacional", icon: <CheckIcon color="success" /> },
        { label: "IRPF sob demanda: até 1 sócio incluso", icon: <CloseIcon color="success" /> },
        { label: "Emissão via Clarea Fácil: até 3 NF/mês", icon: <CloseIcon color="success" /> },
        { label: "Apenas pró-labore do sócio", icon: <CloseIcon color="success" /> },
        { label: "Emissões/mês feitas pela equipe Clarea", icon: <CloseIcon color="error" /> },
        { label: "Folha de pagamento de colaboradores", icon: <CloseIcon color="error" /> },
        { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", icon: <CloseIcon color="error" /> },
    ],
    "Profissional": [
        { label: "Faturamento da PJ até: R$ 60.000/mês", icon: <CheckIcon color="success" /> },
        { label: "Composição societária: até 2 sócios", icon: <CheckIcon color="success" /> },
        { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", icon: <CheckIcon color="success" /> },
        { label: "Obrigações fiscais/contábeis: completas dentro do Simples Nacional", icon: <CheckIcon color="success" /> },
        { label: "Certificado digital incluso: apenas no plano anual", icon: <CheckIcon color="success" /> },
        { label: "Regime tributário: Simples Nacional", icon: <CheckIcon color="success" /> },
        { label: "IRPF sob demanda: até 2 sócios inclusos", icon: <CheckIcon color="success" /> },
        { label: "Emissão via Clarea Fácil: ilimitada", icon: <CheckIcon color="success" /> },
        { label: "Pró-labore dos sócios", icon: <CheckIcon color="success" /> },
        { label: "Emissões/mês feitas pela equipe Clarea: até 10", icon: <CheckIcon color="success" /> },
        { label: "Folha de pagamento até 2 colaboradores", icon: <CheckIcon color="success" /> },
        { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", icon: <CloseIcon color="error" /> },
    ],
    "Premium": [
        { label: "Faturamento da PJ até: R$ 150.000/mês", icon: <CheckIcon color="success" /> },
        { label: "Composição societária: até 3 sócios", icon: <CheckIcon color="success" /> },
        { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", icon: <CheckIcon color="success" /> },
        { label: "Obrigações fiscais/contábeis: completas dentro do Simples Nacional", icon: <CheckIcon color="success" /> },
        { label: "Certificado digital incluso: apenas no plano anual", icon: <CheckIcon color="success" /> },
        { label: "Regime tributário: Simples Nacional", icon: <CheckIcon color="success" /> },
        { label: "IRPF sob demanda: até 3 sócios inclusos", icon: <CheckIcon color="success" /> },
        { label: "Emissão via Clarea Fácil: ilimitada", icon: <CheckIcon color="success" /> },
        { label: "Pró-labore dos sócios", icon: <CheckIcon color="success" /> },
        { label: "Emissões/mês feitas pela equipe Clarea: até 20", icon: <CheckIcon color="success" /> },
        { label: "Folha de pagamento: até 3 colaboradores", icon: <CheckIcon color="success" /> },
        { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", icon: <CloseIcon color="error" /> },
    ],
    "Expert": [
        { label: "Faturamento da PJ até: R$ 400.000/mês (R$ 4,8 milhões/ano – teto do Simples Nacional)", icon: <CheckIcon color="success" /> },
        { label: "Composição societária: até 3 sócios", icon: <CheckIcon color="success" /> },
        { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", icon: <CheckIcon color="success" /> },
        { label: "Obrigações fiscais/contábeis: completas dentro do Simples Nacional", icon: <CheckIcon color="success" /> },
        { label: "Certificado digital incluso: apenas no plano anual", icon: <CheckIcon color="success" /> },
        { label: "Regime tributário: Simples Nacional", icon: <CheckIcon color="success" /> },
        { label: "IRPF sob demanda: até 3 sócios inclusos", icon: <CheckIcon color="success" /> },
        { label: "Emissão via Clarea Fácil: ilimitada", icon: <CheckIcon color="success" /> },
        { label: "Pró-labore dos sócios", icon: <CheckIcon color="success" /> },
        { label: "Emissões/mês feitas pela equipe Clarea: até 30", icon: <CheckIcon color="success" /> },
        { label: "Folha de pagamento: até 5 colaboradores", icon: <CheckIcon color="success" /> },
        { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", icon: <CheckIcon color="success" /> },
    ],
    "Plus Personalizado": [
        { label: "Estrutura adaptada a regimes Lucro Presumido ou Lucro Real", icon: <CheckIcon color="success" /> },
        { label: "Planejamento tributário e societário completo", icon: <CheckIcon color="success" /> },
        { label: "Consultoria contábil e estratégica personalizada", icon: <CheckIcon color="success" /> },
        { label: "Suporte dedicado e reuniões sob demanda", icon: <CheckIcon color="success" /> },
    ]
}


const MudarPlano = () => {
    const { user, fetchUser } = useUser();
    const navigate = useNavigate();
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [openConfirmarMudarPlano, setOpenConfirmarMudarPlano] = useState(false);
    const [idPlanoEscolhido, setIdPlanoEscolhido] = useState(null);
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const scrollRef = useRef(null);
    const scrollLeft = () => {
        scrollRef.current.scrollBy({ left: -360, behavior: "smooth" });
    };

    const scrollRight = () => {
        scrollRef.current.scrollBy({ left: 360, behavior: "smooth" });
    };


    useEffect(() => {
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;

        if (hasFaturasVencidas) {
            setUserActive(false);
        } else {
            setUserActive(true);
        }
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes)
            }
        }

        getNotify();
    }, [])

    const [objPlanos, setObjPlanos] = useState([]);

    useEffect(() => {
        const getPlanos = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/mudarPlano/getPlanos/${user?.plano?.idPlano}`, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                const data = response.data.data;
                const updatedData = data.map(plan => {
                    plan.chips = planosChip[plan.nome];
                    return plan;
                });
                console.log(updatedData);
                setObjPlanos(updatedData);
            }
        };

        if (user?.plano?.idPlano) {
            getPlanos();
        }
    }, [user?.plano?.idPlano]);


    const handleChangePlan = async () => {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/mudarPlano/mudarPlano`, { idPlanoEscolhido }, {
            headers: {
                Authorization: `${localStorage.getItem("token")}`
            }
        });
        console.log(response);
        if (response.data.status === 200) {
            setOpenSnackbarSuccess(true);
        }
        fetchUser();
    }


    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <div style={{ padding: "30px", background: "#f4f6f8", minHeight: "100vh", marginTop: "64px" }}>
                <div style={{ width: "100%", height: "fit-content", padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "80%", height: "fit-content" }}>
                        <IconButton onClick={() => navigate("../Dashboard")}>
                            <ArrowBackIcon sx={{ fontSize: "40px", color: "black" }} />
                        </IconButton>
                    </div>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={{
                        width: "70%",
                        border: "1px solid #eee",
                        borderRadius: "8px",
                        padding: "20px",
                        background: "#fff",
                        minWidth: "400px"
                    }}>
                        <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
                            Mudar Plano
                        </Typography>
                        <Divider />

                        <Typography variant="body1" sx={{ mt: 2 }}>
                            Aqui você pode visualizar e escolher um novo plano de assinatura.
                            Caso tenha faturas pendentes, regularize sua situação para poder realizar a troca de plano e continuar utilizando nossos serviços normalmente.
                        </Typography>
                        <div
                            className="scroll-buttons"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                margin: "20px 0",
                                gap: "10px",
                            }}
                        >
                            <Button onClick={scrollLeft} variant="contained" sx={{
                                padding: "14px 28px",
                                fontSize: "1rem",
                                backgroundColor: "#ffc845",
                                color: "#0b243d",
                                borderRadius: "10px",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                transition: "0.3s ease",
                                '&:hover': {
                                    backgroundColor: "#e6b53e",
                                    transform: "scale(1.05)",
                                },
                            }}>
                                ◀
                            </Button>
                            <Button onClick={scrollRight} variant="contained" sx={{
                                padding: "14px 28px",
                                fontSize: "1rem",
                                backgroundColor: "#ffc845",
                                color: "#0b243d",
                                borderRadius: "10px",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                transition: "0.3s ease",
                                '&:hover': {
                                    backgroundColor: "#e6b53e",
                                    transform: "scale(1.05)",
                                },
                            }}>
                                ▶
                            </Button>
                        </div>
                        <div ref={scrollRef}
                            style={{
                                display: "flex",
                                // justifyContent: "center",
                                gap: "20px",
                                overflowX: "auto",
                                scrollSnapType: "x mandatory",
                                paddingBottom: "20px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}>
                            {objPlanos.map((plan, i) => (
                                <motion.div
                                    key={i}
                                    custom={i}
                                    variants={cardVariants}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.3 }}
                                    style={{
                                        width: "90vw",
                                        maxWidth: "360px",
                                        flex: "0 0 auto",
                                        scrollSnapAlign: "start",
                                        border: "1px solid #ccc",
                                        borderRadius: "30px",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                        padding: "10px",
                                        backgroundColor: "#f9f2e4",
                                    }}
                                >
                                    <div style={{ position: "relative", height: "40px" }}>
                                        <h3 style={{ textAlign: "center", color: "red", display: plan?.idPlano === user?.plano?.idPlano ? "block" : "none" }}>Plano Atual</h3>
                                    </div>
                                    <h1 style={{ textAlign: "center" }}>{plan.nome}</h1>
                                    <p style={{ fontSize: "12px", marginBottom: "10px", textAlign: "center" }}>{plan.descricao}</p>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <p style={{ fontSize: "15px", marginRight: "5px" }}>
                                            {Number(plan?.valorAntigoMensal) ? Number(plan?.valorAntigoMensal)?.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ""}
                                        </p>
                                        <p
                                            style={{
                                                fontSize: "13px",
                                                backgroundColor: "#0b243d",
                                                padding: "1px 5px",
                                                borderRadius: "10px",
                                                color: "white",
                                            }}
                                        >
                                            {Number(plan.descontoMensal) > 0 ? (
                                                <>{parseInt(plan.descontoMensal)}%OFF</>
                                            ) : ("")}
                                        </p>
                                    </div>
                                    {plan.nome === "Plus Personalizado" ? (
                                        <p style={{ fontSize: "25px", textAlign: "center" }}>
                                            <strong>Sob consulta</strong>
                                        </p>
                                    ) : (
                                        <p style={{ fontSize: "25px", textAlign: "center" }}>
                                            <strong> <b style={{ fontSize: "12px", fontWeight: "normal" }}>POR</b> R$ {Number(plan.valorNovoMensal).toFixed(2).replace(".", ",")}</strong>
                                        </p>
                                    )}
                                    <div style={{ display: "flex", justifyContent: "center", padding: "20px 0", height: "100px" }}>
                                        <div>
                                            {plan.nome !== "Plus Personalizado" ? (
                                                <Button variant="contained" sx={{
                                                    display: plan?.idPlano === user?.plano?.idPlano ? "none" : "block",
                                                    padding: "14px 28px",
                                                    fontSize: "1rem",
                                                    backgroundColor: "#ffc845",
                                                    color: "#0b243d",
                                                    borderRadius: "10px",
                                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                                    transition: "0.3s ease",
                                                    '&:hover': {
                                                        backgroundColor: "#e6b53e",
                                                        transform: "scale(1.05)",
                                                    },
                                                }}
                                                    onClick={() => {
                                                        setIdPlanoEscolhido(plan.idPlano);
                                                        setOpenConfirmarMudarPlano(true);
                                                    }}
                                                >
                                                    assinar plano
                                                </Button>

                                            ) : (
                                                <Button variant="contained" sx={{
                                                    display: plan?.idPlano === user?.plano?.idPlano ? "none" : "block",
                                                    padding: "14px 28px",
                                                    fontSize: "1rem",
                                                    backgroundColor: "#ffc845",
                                                    color: "#0b243d",
                                                    borderRadius: "10px",
                                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                                    transition: "0.3s ease",
                                                    '&:hover': {
                                                        backgroundColor: "#e6b53e",
                                                        transform: "scale(1.05)",
                                                    },
                                                }}
                                                    onClick={() => {
                                                        window.open(gerarLinkWhatsApp("Olá, tenho interesse no plano *Plus Personalizado* (Sob Consulta). Poderia me enviar mais informações?"), '_blank');
                                                    }}
                                                >
                                                    Solicitar contato
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        {plan.chips.map((chip, idx) => (
                                            <motion.div
                                                key={idx}
                                                custom={idx}
                                                variants={chipVariants}
                                                initial="hidden"
                                                whileInView="visible"
                                                viewport={{ once: true, amount: 0.3 }}
                                                style={{ textAlign: "center" }}
                                            >
                                                <Chip
                                                    sx={{
                                                        height: "auto",
                                                        border: "none",
                                                        "& .MuiChip-label": { display: "block", whiteSpace: "normal" },
                                                    }}
                                                    icon={chip.icon}
                                                    label={chip.label}
                                                    variant="outlined"
                                                />
                                            </motion.div>
                                        ))}
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </div >
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <ConfirmarMudarPlano
                openConfirmarMudarPlano={openConfirmarMudarPlano}
                setOpenConfirmarMudarPlano={setOpenConfirmarMudarPlano}
                handleChangePlan={handleChangePlan}
            />
            <AlertSuccess setOpenSnackbarSuccess={setOpenSnackbarSuccess} openSnackbarSuccess={openSnackbarSuccess} mensagem={"Plano alterado com sucesso!"} />
        </>
    )
}

export default MudarPlano;